import { render, staticRenderFns } from "./committeeManager.vue?vue&type=template&id=1571dc5c"
import script from "./committeeManager.vue?vue&type=script&lang=js"
export * from "./committeeManager.vue?vue&type=script&lang=js"
import style0 from "./committeeManager.vue?vue&type=style&index=0&id=1571dc5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports